import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons";

/**
 * Điều kiện & lưu ý quan trọng + Câu hỏi thường gặp của chương trình "Giới thiệu bạn mới".
 * Tách riêng khỏi trang Ref để trang chính gọn, dễ cập nhật nội dung điều khoản.
 */

const NOTES = [
    "Chỉ đơn hàng được duyệt hoàn tiền thành công mới được tính hoa hồng.",
    "Cần cập nhật thông tin tài khoản nhận tiền để rút hoa hồng đã duyệt.",
    "Không hợp lệ: tự giới thiệu bản thân; dùng chung thiết bị để đăng ký; đăng công khai link giới thiệu để câu traffic; tạo lưu lượng ảo. Vi phạm sẽ bị từ chối hoặc thu hồi hoa hồng, tài khoản có thể bị khóa nếu tái phạm.",
    "Longhousee có quyền điều chỉnh chương trình bất kỳ lúc nào; hoa hồng đã duyệt trước đó vẫn được giữ nguyên.",
];

const FAQS = [
    {
        q: "Tôi cần bao nhiêu đơn hàng để giới thiệu bạn bè?",
        a: "Tối thiểu 5 đơn hàng đã được duyệt hoàn tiền thành công.",
    },
    {
        q: "Giới thiệu thành công là gì?",
        a: "Là khi bạn mới đăng ký và nhập mã giới thiệu thành công. Tuy nhiên hoa hồng chỉ phát sinh khi người đó có đơn hàng và được duyệt hoàn tiền.",
    },
    {
        q: "Vì sao tôi chưa nhận được hoa hồng?",
        a: "Có thể do: bạn mới chưa phát sinh đơn hàng, đơn đang chờ duyệt, đơn bị hủy/từ chối, hoặc đã quá 3 tháng kể từ ngày giới thiệu.",
    },
    {
        q: "Tôi nhận được bao nhiêu hoa hồng?",
        a: "Theo % hoàn tiền tùy sàn: Shopee 10%, Lazada 5%, TikTok Shop 5%.",
    },
    {
        q: "Thời gian hưởng quyền lợi bao lâu?",
        a: "Tối đa 3 tháng kể từ ngày bạn mới đăng ký/nhập mã thành công.",
    },
    {
        q: "Dùng chung thiết bị hoặc tự giới thiệu bản thân có được tính không?",
        a: "Không. Đây là hành vi không hợp lệ và sẽ không được tính thưởng.",
    },
];

function ReferralTermsAndFaq() {
    return (
        <>
            <section className="bg-surface rounded-lg shadow p-2 text-sm">
                <p className="font-semibold mb-2">Điều kiện & lưu ý quan trọng:</p>
                <ul className="flex flex-col gap-2">
                    {NOTES.map((note, index) => (
                        <li key={index} className="flex gap-2 items-start text-content-2">
                            <FontAwesomeIcon icon={faCircleCheck} className="text-green-600 mt-1 shrink-0" />
                            <span>{note}</span>
                        </li>
                    ))}
                </ul>
            </section>

            <section className="bg-surface rounded-lg shadow p-2 text-sm">
                <p className="font-semibold mb-2">Câu hỏi thường gặp:</p>
                <div className="flex flex-col">
                    {FAQS.map((item, index) => (
                        <details
                            key={item.q}
                            className={`py-2 group ${index === FAQS.length - 1 ? "" : "border-b"}`}
                        >
                            <summary className="flex gap-2 justify-between items-center cursor-pointer font-medium list-none">
                                <span>{item.q}</span>
                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    className="text-content-3 text-xs shrink-0 transition-transform group-open:rotate-180"
                                />
                            </summary>
                            <p className="mt-2 text-content-2">{item.a}</p>
                        </details>
                    ))}
                </div>
            </section>
        </>
    );
}

export default ReferralTermsAndFaq;
